<script setup lang="ts">
import { Ref, ref } from "vue";
import { useI18n } from "vue-i18n";
import CreateExportScheduleDTO = App.Data.ExportScheduler.CreateExportScheduleDTO;
import { required, titleInputRules } from "@/ui/validation/validationRules";
import { useApiClient } from "@/api/client";
import ExportTypeDO = App.Data.ExportScheduler.ExportTypeDO;
import { onBeforeMount } from "vue";
import { ucfirst } from "chartjs-graph";
import { toastApiResult } from "@/toaster";
import router from "@/router/router";
import Modal from "@/ui/components/modal.vue";
const isDialogVisible = defineModel<boolean>();

const { t } = useI18n();

const scheduleToSave: Ref<CreateExportScheduleDTO> = ref({
	title: "",
	export_type_id: null,
});

const isFormValid: Ref<boolean> = ref(false);
const exportTypes: Ref<ExportTypeDO[]> = ref();

const getExportTypes = async () => {
	const response = await useApiClient("exportSchedules").getExportTypes();
	if (response.isOk()) {
		exportTypes.value = response.value;
	}
};

const createSchedule = async () => {
	const response = await toastApiResult(
		useApiClient("exportSchedules").create(scheduleToSave.value)
	);
	if (response.isOk()) {
		router.push(`/scheduler/${response.value.uuid}`);
	}
};

onBeforeMount(() => {
	getExportTypes();
});
</script>

<template>
	<Modal
		v-model:visible="isDialogVisible"
		title="New scheduled export"
		icon="fa-duotone fa-calendar-clock fa-lg"
		width="400px"
		:allow-submit="isFormValid"
		@submit="createSchedule"
	>
		<v-form v-model="isFormValid" class="d-flex flex-column ga-2">
			<v-text-field
				v-model="scheduleToSave.title"
				label="Title"
				hide-details="auto"
				:rules="titleInputRules(t)"
			/>
			<v-select
				v-model="scheduleToSave.export_type_id"
				label="Export Type"
				:items="exportTypes"
				:item-title="
					(property) =>
						ucfirst(t(`scheduler.export_types.${property.name_clean}`))
				"
				item-value="id"
				hide-details="auto"
				validate-on="input"
				:rules="[required(t)]"
				data-testid="scheduler-export-type-select"
			/>
		</v-form>
	</Modal>
</template>

<style lang="scss"></style>
